goog.module('yext.location.StringList');
goog.module.declareLegacyNamespace();

const locationcluster = goog.require('yext.locationcluster');
const ClusterGuardOldStyleField = goog.require('yext.locationcluster.ClusterGuardOldStyleField');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');

// TODO(paige) remove dependency on enableSubmit, & onFieldEdit
/**
 * @constructor
 *
 * Stringlist Object
 * @param {!jQuery} $container the stringlist container
 *
 * supportedOptions {
 *    isEditMode: false,  // determines whether to show it in the input edit status,
 *    isPlainMode: false // determines whether to bind UI listeners
 *    field: 'associations', // the name of the editable field for form submission
 *    form: '.some-selector', // the form container inside of the stringlist (not always a form)
 *    container: $('.some-selector-container') // the wrapper container with all the click handlers etc
 */
const StringList = function(options) {
  this.options = options;

  if (!options || !options.container) {
    // container doesn't exist throw an error
    throw new Error('Stringlist container not found');
  }
  this.$container = options.container;

  if (!options.isPlainMode) {
    this.bindAdd();
    this.bindEdit();
    this.bindRemove();
    this.bindElidedRemove();
  }

  // set directly to edit mode, otherwise assume in preview mode (locationEdit)
  if (options.isEditMode) {
    this.$container.find('.js-stringlist-field-edit').show();
  }
};

/**
 * Bind adding a new stringlist event listener
 */
StringList.prototype.bindAdd = function() {
  var self = this;
  this.$container.on('click', '.js-stringlist-add', function(e) {
    self.onAdd($(this), e);
  });
};

/**
 * Bind action to set stringlist to edit mode
 * TODO(Paige) Move to Editble Stringlist?
 * or make this setable (maybe they are open by default)
 */
StringList.prototype.bindEdit = function() {
  var self = this;
  this.$container.on('click', '.js-stringlist-field-display', function(e) {
    self.onEdit($(this), e);
  });
};

/**
 * Bind action to remove state
 */
StringList.prototype.bindRemove = function() {
  var self = this;

  this.$container.on('click', '.js-stringlist-remove', function(e) {
    var $this = $(this);
    self.onRemove(e, $this);
  });
};

/**
 * bind action to elided remove state
 */
StringList.prototype.bindElidedRemove = function() {
  var self = this;
  this.$container.on('click', '.js-stringlist-elided-remove', function(e) {
    self.onElidedRemove(e, $(this));
  });
};

/**
 * bind action to submit form state
 */
StringList.prototype.bindSubmit = function() {
  var self = this;
  this.$container.find('.js-stringlist-form').submit(function(e) {
    e.preventDefault();
    self.onSubmit(this);
  });
};

/**
 * Reacting to the onAdd event click handler
 * @param {JQueryObject} $el the clicked element as a jQuery
 * @param {Event} e the event
 */
StringList.prototype.onAdd = function($el, e) {
  e.stopPropagation();
  var $ul = $el.siblings('.stringlist-items');
  $ul.find('.remove').show();
  $ul.find('.reorder-icon').show();
  $ul.append($ul.children('.template').clone()
    .removeClass('template')
    .css('display', 'list-item'));
  this.updated($el.closest('.stringlist-edit'));
  window.enableSubmit($ul.parents('form')[0]);
};

/**
 * Reacting to the onEdit event click handler
 * @param  {!jQuery} $container the container the event was called on
 * @param  {Event} e the event
 */
StringList.prototype.onEdit = function($container, e) {
  if (e) {
    e.stopPropagation();
  }

  var self = this;

  var callback = function(display, edit, e) {
    self.setup(edit);
    $('.stringlist-edit').show();
    $('.stringlist-input').inputchange(function() {
      self.onChange(this);
    });

    // for custom text list fields, the custom field timestamp does not
    // get updated at the same time as other custom fields, because unlike
    // the other field types, string list uses the text template pattern
    // workaround: we store a copy of the timestamp outside of the text template,
    // and put it in the template after it has been rendered
    var $ts = display.find('.js-custom-textlist-timestamp-outer');
    edit.find('.js-custom-textlist-timestamp-inner').val($ts.val());
  };

  // onFieldEdit returns a function that is called on the edit container and the event
  var editFunction = window.onFieldEdit(callback);
  editFunction($container, e);
  this.bindSubmit(); // only submit when we are in edit mode
  return false;
};

/**
 * Reacting to the onRemove click handler
 * @param {Event} e the event
 * @param {!jQuery} $el the clicked element
 */
StringList.prototype.onRemove = function(e, $el) {
  e.stopPropagation();
  var $li = $el.parents('li').first();
  var $ul = $li.parents('ul').first();
  var $form = $ul.parents('form').first();

  $li.remove();
  $el.closest('form').data('changed', true);

  var $remainingLi = $ul.children('li:not(.template)');

  if ($remainingLi.length < $form.find('input[name=max-items]').val()) {
    this.updated($form);
  }

  window.enableSubmit($form[0]);
};

/**
 * Reacting to the onElided Click handler
 * @param {Event} e the event
 * @param {!jQuery} $el the clicked element
 */
StringList.prototype.onElidedRemove = function(e, $el) {
  e.stopPropagation();
  var $div = $el.parents('.stringlist-elided').first();
  var $form = $div.parents('form').first();
  var field = $el.data('fieldName');

  $div.remove();
  $el.closest('form').data('changed', true);
  $form.find('input[name="' + field + '.elided"]').val('0');
  window.enableSubmit($form[0]);
};

/**
 * Reacting to the onSubmit Click Handler
 * @param {string} form form selector
 */
StringList.prototype.onSubmit = function(form) {
  var field = this.options.field || $(form).data('fieldName');
  var data = this.serializeForm(form, field);

  // Bind cluster warning dialog
  if (locationcluster.shouldShowWarningDialog(field)) {
    new locationcluster.ClusterGuardOldStyleField(form, data);
    return;
  }

  window.onFieldSave(form, data);
};

/**
 * Set the max and min items view for Stringlist
 * @param  {!jQuery} $edit element triggered for update
 */
StringList.prototype.updated = function($edit) {
  var maxItems = $edit.find('li:not(.template) input:checked').length >=
  $edit.find('input[name=max-items]').val();
  $edit.find('.stringlist-add').toggle(!maxItems);
  $edit.find('.stringlist-max').toggle(maxItems);
};

/**
 * Setting up Stringlist to be editted
 * @param  {!jQueryObect} $el jQuery that's ready to be edited
 */
StringList.prototype.setup = function($el) {
  var self = this;
  $el.find('.indeterminate').prop('indeterminate', true);
  var list = $el.find('.stringlist-items');
  list.sortable({
    axis: 'y',
    change: function() {
      $(this).parents('form')
        .find('.stringlist-ordervariesmsg').remove().end()
        .find('.stringlist-reordered').val('true').end()
        .each(function() {
          window.enableSubmit(this);
        });
    },
    containment: list,
    tolerance: 'pointer',
  });
  var $edit = $el.closest('.stringlist-edit');
  list.delegate('input:checkbox', 'change click', function() {
    self.updated($el);
  });
  self.updated($el);
};

/**
 * Binding onChange event to stringlist inputs
 * @param  {string} el input containing selector
 */
StringList.prototype.onChange = function(el) {
  window.enableSubmit(el.form);

  var $el = $(el);
  var original = $el.data('original');
  if (original) {
    var $check = $el.parents('li').first().find('input:checkbox');
    if ($check.prop('indeterminate')) {
      // NOTE(eefi): Because we're hooking into the native onkeyup instead of
      // using jQuery's .keyup(), val() hasn't been updated yet, so we need
      // to wait until it has before running this check...
      setTimeout(function() {
        if ($el.val() !== original) {
          $check.prop('indeterminate', false).prop('checked', true);
          $el.data('original', '');
        }
      }, 0);
    }
  }
};


/**
 * [serializeForm description]
 * @param  {string} form  form selector
 * @param  {string} sfield field selector
 *
 *  NOTE(eefi): This method also does some setup for validation error
 *  handling. Seems like a poor separation of concerns...
 */
StringList.prototype.serializeForm = function(form, sfield) {
  var $container;
  if (form) {
    $container = $(form);
  } else {
    $container = this.$container;
  }
  var field = sfield || this.options.field;
  var $list = this.options.list || $container.find('#' + field + 'List.stringlist-items');
  if ($list.length == 0) {
    // Nothing found to serialize
    return [];
  }
  $list.find('input[type="text"].error').removeClass('error');
  var $timestamp = $container.find('input[name="' + field + '.timestamp"]');
  var $reordered = $container.find('input[name="' + field + '.reordered"]');
  var $elided = $container.find('input[name="' + field + '.elided"]');

  var data = [
    {name: 'field', value: field},
    {
      name: field + '.timestamp',
      value: $timestamp.length > 0 ? $timestamp.val() : 0,
    },
    {
      name: field + '.reordered',
      value: $reordered.length > 0 ? $reordered.val() : false,
    },
    {
      name: field + '.elided',
      value: $elided.length > 0 ? $elided.val() : false,
    },
  ];
  var count = 0;
  $list.children('li').each(function() {
    var $this = $(this);
    $this.find('input[type="text"]').removeAttr('name');

    if ($this.hasClass('template')) {
      return;
    }

    var $check = $this.find('input[type="checkbox"]');
    if (!$check.prop('indeterminate') && !$check.prop('checked')) {
      return;
    }
    var onAllLocs = !$check.prop('indeterminate');

    var item = $.trim($this.find('input[type="text"]').val());
    if (!item) {
      return;
    }

    $this.find('input[type="text"]')
    // Setting attr for benefit of possible error display.
      .attr('name', field + '.item' + count + '.value');
    data.push(
      {name: field + '.item' + count + '.value', value: item},
      {name: field + '.item' + count + '.onAllLocs', value: onAllLocs});
    ++count;
  });
  data.push({name: field + '.count', value: count});
  return data;
};

exports = StringList;
